









































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RolesModule } from '@/store/Settings/RolesModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateUpdateRoleRequest from '@/models/Settings/Roles/CreateUpdateRoleRequest';

@Component({ name: 'RoleEdit' })
export default class extends SaascadaVueDialog {

    request: CreateUpdateRoleRequest = new CreateUpdateRoleRequest();

    get institutionConfig() {
        return AuthModule.me.institution.config;
    }

    get institutionLabels() {
        return AuthModule.me.institution.config.labels;
    }

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateUpdateRoleRequest();
            const role = RolesModule.role;
            this.request.name = role.name;
            this.request.readThirdPartyAccounts = role.readThirdPartyAccounts;
            this.request.manageThirdPartyAccounts = role.manageThirdPartyAccounts;
            this.request.readInstitutionalAccounts = role.readInstitutionalAccounts;
            this.request.manageInstitutionalAccounts = role.manageInstitutionalAccounts;
            this.request.manageInstitutionalPaymentOrders = role.manageInstitutionalPaymentOrders;
            this.request.readCustomerAccounts = role.readCustomerAccounts;
            this.request.manageCustomerAccounts = role.manageCustomerAccounts;
            this.request.manageCustomerPaymentOrders = role.manageCustomerPaymentOrders;
            this.request.readLendingAccounts = role.readLendingAccounts;
            this.request.manageLendingAccounts = role.manageLendingAccounts;
            this.request.readProducts = role.readProducts;
            this.request.manageProducts = role.manageProducts;
            this.request.readAccounting = role.readAccounting;
            this.request.manageAccounting = role.manageAccounting;
            this.request.readReports = role.readReports;
            this.request.manageReports = role.manageReports;
            this.request.readUsers = role.readUsers;
            this.request.manageUsers = role.manageUsers;
            this.request.readRoles = role.readRoles;
            this.request.manageRoles = role.manageRoles;
            this.request.readInstitutionSettings = role.readInstitutionSettings;
            this.request.manageInstitutionSettings = role.manageInstitutionSettings;
            this.request.readAppMediums = role.readAppMediums;
            this.request.manageAppMediums = role.manageAppMediums;
            this.request.readWebhooks = role.readWebhooks;
            this.request.manageWebhooks = role.manageWebhooks;
        }
    }

    @Watch('request.readThirdPartyAccounts')
    async onReadThirdPartyAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageThirdPartyAccounts = false;
        }
    }

    @Watch('request.manageThirdPartyAccounts')
    async onManageThirdPartyAccountsChanged(val: boolean) {
        if (val) {
            this.request.readThirdPartyAccounts = true;
        }
    }

    @Watch('request.readInstitutionalAccounts')
    async onReadInstitutionalAccountsChanged(val: boolean) {
        if (!val) {
            this.request.manageInstitutionalAccounts = false;
            this.request.manageInstitutionalPaymentOrders = false;
        }
    }

    @Watch('request.manageInstitutionalAccounts')
    async onManageInstitutionalAccountsChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionalAccounts = true;
        }
    }

    @Watch('request.manageInstitutionalPaymentOrders')
    async onManageInstitutionalPaymentOrdersChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionalAccounts = true;
        }
    }

    @Watch('request.readCustomerAccounts')
    async onReadCustomerAccountsChanged(val: boolean) {
        if (val) {
            // If you have read permissions on customer accounts you also need it for products
            this.request.readProducts = true;
        }
        else {
            // Else if you don't then you can't have manage permissions on accounts or payment orders
            this.request.manageCustomerAccounts = false;
            this.request.manageCustomerPaymentOrders = false;
        }
    }

    @Watch('request.manageCustomerAccounts')
    async onManageCustomerAccountsChanged(val: boolean) {
        if (val) {
            this.request.readCustomerAccounts = true;
        }
    }

    @Watch('request.manageCustomerPaymentOrders')
    async onManageCustomerPaymentOrdersChanged(val: boolean) {
        if (val) {
            this.request.readCustomerAccounts = true;
        }
    }

    @Watch('request.readLendingAccounts')
    async onReadLendingAccountsChanged(val: boolean) {
        if (val) {
            // If you have read permissions on lending accounts you also need it for products
            this.request.readProducts = true;
        }
        else {
            // Else if you don't then you can't have manage permissions on accounts
            this.request.manageLendingAccounts = false;
        }
    }

    @Watch('request.manageLendingAccounts')
    async onManageLendingAccountsChanged(val: boolean) {
        if (val) {
            this.request.readLendingAccounts = true;
        }
    }

    @Watch('request.readProducts')
    async onReadProductsChanged(val: boolean) {
        if (!val) {
            this.request.manageProducts = false;
        }
    }

    @Watch('request.manageProducts')
    async onManageProductsChanged(val: boolean) {
        if (val) {
            this.request.readProducts = true;
        }
    }


    @Watch('request.readAccounting')
    async onReadAccountingChanged(val: boolean) {
        if (!val) {
            this.request.manageAccounting = false;
        }
    }

    @Watch('request.manageAccounting')
    async onManageAccountingChanged(val: boolean) {
        if (val) {
            this.request.readAccounting = true;
        }
    }

    @Watch('request.readReports')
    async onReadReportsChanged(val: boolean) {
        if (!val) {
            this.request.manageReports = false;
        }
    }

    @Watch('request.manageReports')
    async onManageReportsChanged(val: boolean) {
        if (val) {
            this.request.readReports = true;
        }
    }

    @Watch('request.readUsers')
    async onReadUsersChanged(val: boolean) {
        if (!val) {
            this.request.manageUsers = false;
        }
    }

    @Watch('request.manageUsers')
    async onManageUsersChanged(val: boolean) {
        if (val) {
            this.request.readUsers = true;
        }
    }

    @Watch('request.readRoles')
    async onReadRolesChanged(val: boolean) {
        if (!val) {
            this.request.manageRoles = false;
        }
    }

    @Watch('request.manageRoles')
    async onManageRolesChanged(val: boolean) {
        if (val) {
            this.request.readRoles = true;
        }
    }

    @Watch('request.readInstitutionSettings')
    async onReadInstitutionSettingsChanged(val: boolean) {
        if (!val) {
            this.request.manageInstitutionSettings = false;
        }
    }

    @Watch('request.manageInstitutionSettings')
    async onManageInstitutionSettingsChanged(val: boolean) {
        if (val) {
            this.request.readInstitutionSettings = true;
        }
    }

    @Watch('request.readAppMediums')
    async onReadAppMediumsChanged(val: boolean) {
        if (!val) {
            this.request.manageAppMediums = false;
        }
    }

    @Watch('request.manageAppMediums')
    async onManageAppMediumsChanged(val: boolean) {
        if (val) {
            this.request.readAppMediums = true;
        }
    }

    @Watch('request.readWebhooks')
    async onReadAWebHooksChanged(val: boolean) {
        if (!val) {
            this.request.manageWebhooks = false;
        }
    }

    @Watch('request.manageWebhooks')
    async onManageWebhooksChanged(val: boolean) {
        if (val) {
            this.request.readWebhooks = true;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await RolesModule.editRole(this.request);
        }
    }

}
